// Custom select dropdown implementation for expertise and category filters

const expertiseSelect = document.querySelector<HTMLSelectElement>('#expertise');
const expertiseCustomSelect = document.getElementById('custom-expertise-select');
const expertiseSelected = document.getElementById('selected-expertise');
const expertiseSelectedText = document.getElementById('selected-expertise-text');
const expertiseOptions = document.getElementById('expertises-options');
const expertiseOptionItems = expertiseOptions?.querySelectorAll<HTMLLIElement>('li');

// Toggle dropdown
expertiseSelected?.addEventListener('click', () => expertiseOptions?.classList.toggle('hidden'));

// Close on click outside
document.addEventListener('click', (e) => {
    if (!expertiseCustomSelect?.contains((e as MouseEvent)?.target as Node)) expertiseOptions?.classList.add('hidden');
});


const params = new URLSearchParams(document.location.search);
const expertiseParams = params.get("expertise");
if (expertiseParams && expertiseSelectedText){
    expertiseSelectedText.textContent = document.querySelector('#expertise option:checked')?.textContent ?? null;
}


// Update selection
expertiseOptionItems?.forEach(option => {
    option.addEventListener('click', () => {
        if (expertiseSelectedText) expertiseSelectedText.textContent = option.textContent;
        if (expertiseSelect) expertiseSelect.value = option.dataset.value || '';

        expertiseOptions?.classList.add('hidden');
        // notify listeners and submit the form containing the select (if any)
        if (expertiseSelect) {
            expertiseSelect.dispatchEvent(new Event('input', { bubbles: true }));
            expertiseSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const form = expertiseSelect?.closest('form') as HTMLFormElement | null;
        if (form) {
            form.submit();
        }
    });
});


const categorySelect = document.querySelector<HTMLSelectElement>('#category');
const categoryCustomSelect = document.getElementById('custom-category-select');
const categorySelected = document.getElementById('selected-category');
const categorySelectedText = document.getElementById('selected-category-text');
const categoryOptions = document.getElementById('categories-options');
const categoryOptionItems = categoryOptions?.querySelectorAll<HTMLLIElement>('li');

// Toggle dropdown
categorySelected?.addEventListener('click', () => categoryOptions?.classList.toggle('hidden'));

// Close on click outside
document.addEventListener('click', (e) => {
    if (!categoryCustomSelect?.contains((e as MouseEvent)?.target as Node)) categoryOptions?.classList.add('hidden');
});

const category = params.get("category");
if (category && categorySelectedText){
    categorySelectedText.textContent = document.querySelector('#category option:checked')?.textContent ?? null;
}


categoryOptionItems?.forEach(option => {
    option.addEventListener('click', () => {
        if (categorySelectedText) categorySelectedText.textContent = option.textContent;
        if (categorySelect) categorySelect.value = option.dataset.value || '';

        categoryOptions?.classList.add('hidden');
        // notify listeners and submit the form containing the select (if any)
        if (categorySelect) {
            categorySelect.dispatchEvent(new Event('input', { bubbles: true }));
            categorySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const form = categorySelect?.closest('form') as HTMLFormElement | null;
        if (form) {
            form.submit();
        }
    });
});
